// Module
var code = `<video controls>
  <source src="{{videoURL}}" type="video/mp4" />
</video>
`;
// Exports
module.exports = code;